export default __webpack_public_path__ + "static/media/EpilepsyReferralv6220426ReferralguidanceforadultswithepilepsyV6_flowchart.6286ef3d.jpg";